import './AssetCardNewDetailedLoading.css';

export function AssetCardNewDetailedLoading() {
    return (
        <div className="acndl loading">
            <div className="acndl-img" />
            <div className="acndl-body">
                <div className="acndl-badge" />
                <div className="acndl-name" />
                <div className="acndl-desc-line" />
                <div className="acndl-desc-line acndl-desc-line--short" />
                <div className="acndl-footer">
                    <div className="acndl-stat" />
                    <div className="acndl-stat" />
                </div>
            </div>
        </div>
    );
}

export default AssetCardNewDetailedLoading;
